import { useContext } from "react";
import { ApiContext } from "../../contexts/ApiContext";
import { useMutation } from "react-query";
import { RegionSubmission } from "../../shared/interfaces/Region";
import { QueryCallbacks } from "../../shared/interfaces/ReactQuery";

export function useSiteCreation(callbacks?: QueryCallbacks<number>) {
  const apiContext = useContext(ApiContext);
  return useMutation({
    ...callbacks,
    mutationKey: ["submitSite"],
    mutationFn: async (siteSubmission: RegionSubmission) => apiContext.siteApis.createSite(siteSubmission),
  });
}
